<template>
	<nav v-if="data" class="navbar navbar-default navbar-custom">
		<div class="container-fluid">
			<div class="navbar-header navbar-header-custom">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.id" class="navbar-brand navbar-brand-custom bold">
					<template v-if="data.provider">
						Factura {{ $platform.setting.number_symbol }}{{ data.prefix }}{{ data.number_invoice_provider }}
					</template>
					<template v-else>
						Factura {{ $platform.setting.number_symbol }}{{ data.prefix }}{{ data.number }}
					</template>
				</router-link>
			</div>

			<div class="collapse navbar-collapse navbar-collapse-custom" id="bs-example-navbar-collapse-1">
				<ul class="nav navbar-nav">
					<li :class="'list-group-item-' + data.status.class">
						<a @click="$refs.ChangeStatus.open(data)" href="javascript:void(0)">
							<span v-html="data.status.icon"></span>
							<template v-if="data.status.lang">
								{{ data.status.lang.name }}
							</template>
							<template v-else>
								{{ data.status.name }}
							</template>
						</a>
					</li>
					<template v-if="data.parent">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.parent.id">
								<i class="fa fa-file-text" aria-hidden="true"></i>
								Pedido venta {{ $platform.setting.number_symbol }}{{ data.parent.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.customer">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + data.customer.id" :title="data.customer.name">
								<i class="fa fa-address-card-o" aria-hidden="true"></i>
								Cliente
								<template v-if="$platform.setting.customers.custom_reference">
									{{ $platform.setting.number_symbol }}{{ data.customer.reference }}
								</template>
								<template v-else>
									{{ $platform.setting.number_symbol }}{{ data.customer.id }}
								</template>
							</router-link>
						</li>
					</template>
					<template v-else>
						<li>
							<a @click="$refs.addCustomer.open()" href="javascript:void(0)">
								<i class="fa fa-plus fa-fw" aria-hidden="true"></i>
								Añadir cliente
							</a>
						</li>
					</template>
					<template v-if="data.provider">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/providers/' + data.provider.id">
								<i class="fa fa-address-card-o" aria-hidden="true"></i>
								Proveedor #{{ data.provider.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.budget">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets/' + data.budget.id">
								<i class="fa fa-clipboard" aria-hidden="true"></i>
								Presupuesto {{ $platform.setting.number_symbol }}{{ data.budget.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.order">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.order.id">
								<i class="fa fa-clipboard" aria-hidden="true"></i>
								Pedido {{ $platform.setting.number_symbol }}{{ data.order.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.orders">
						<template v-if="data.orders.length > 0">
							<li class="dropdown">
								<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
									<i aria-hidden="true" class="fa fa-file-text"></i>
									Pedidos
									<span class="caret"></span>
								</a>
								<ul class="dropdown-menu">
									<li v-for="order in data.orders">
										<router-link
										:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + order.id">
											<i aria-hidden="true" class="fa fa-file-text"></i>
											Pedido {{ $platform.setting.number_symbol }}{{ order.id }}
										</router-link>
									</li>
								</ul>
							</li>
						</template>
					</template>
					<template v-if="data.rectified">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.rectified.id">
								<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
								Factura rectificativa {{ $platform.setting.number_symbol }}{{ data.rectified.prefix }}{{ data.rectified.number }}
							</router-link>
						</li>
					</template>
					<template v-else>
						<template v-if="data.invoice_status_id == 4">
							<li>
								<a @click="rectify" href="javascript:void(0)">
									<i class="fa fa-retweet" aria-hidden="true"></i>
									Abonar/Rectificar
								</a>
							</li>
						</template>
					</template>
					<template v-if="data.parent">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.parent.id" class="btn btn-default">
								<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
									Factura Ref. {{ data.parent.prefix }}{{ data.parent.number }}
							</router-link>
						</li>
					</template>
					<template v-if="data.project">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + data.project.slug" class="btn btn-default">
								<i class="fa fa-folder-o" aria-hidden="true"></i>
								Proyecto {{ $platform.setting.number_symbol }}{{ data.project.id }}
							</router-link>
						</li>
					</template>
					<template v-if="data.agreement">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/agreements/' + data.agreement.id">
								<i class="fa fa-handshake-o" aria-hidden="true"></i>
								Contrato {{ $platform.setting.number_symbol }}{{ data.agreement.id }}
							</router-link>
						</li>
					</template>
					<template v-else>
						<li>
							<a @click="$refs.addAgreement.open()" href="javascript:void(0)">
								<i class="fa fa-plus" aria-hidden="true"></i>
								Asociar contrato
							</a>
						</li>
					</template>
					<li>
						<a @click="$refs.dueDate.open()" href="javascript:void(0)">
							<template v-if="data.due_date">
								Vencimiento: {{ data.due_date }}
							</template>
							<template v-else>
								<i class="fa fa-plus" aria-hidden="true"></i>
								Vencimiento
							</template>
						</a>
					</li>
				</ul>
				<ul class="nav navbar-nav navbar-right">
					<template v-if="data.invoice_status_id == 1">
						<li v-if="data.customer">
							<a @click="removeCustomer()" href="javascript:void(0)">
								<span class="hidden-xs">
									<i class="fa fa-user-times fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa fa-user-times fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									Remover cliente
								</span>
							</a>
						</li>
					</template>
					<li @click="$refs.withholdings.open()">
						<a href="javascript:void(0)">
							<span class="hidden-xs">
								<i class="fa fa-hand-paper-o" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-hand-paper-o fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Reteneciones
							</span>
						</a>
					</li>
					<li @click="$refs.partialPayments.open()">
						<a href="javascript:void(0)">
							<span class="hidden-xs">
								<i class="fa fa-eur" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-eur fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Pagos parciales
							</span>
						</a>
					</li>
					<li @click="$refs.SendEmail.open(data)">
						<a href="javascript:void(0)" :title="$t('interface.send') | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-paper-plane" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-paper-plane fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $t('interface.send') | ucfirst }}
							</span>
						</a>
					</li>
					<li>
						<a @click="doPrint()" href="javascript:void(0)">
							<span class="hidden-xs">
								<i class="fa fa-print" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-print fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $t('interface.print') | ucfirst }}
							</span>
						</a>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/management/invoices/' + data.random" target= '_blank'>
							<span class="hidden-xs">
								<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-file-pdf-o fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Ver PDF
							</span>
						</router-link>
					</li>
					<li @click="openSettings()">
						<a href="javascript:void(0)" :title="$tc('interface.setting', 1) | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-percent" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-percent fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $tc('interface.setting', 1) | ucfirst }}
							</span>
						</a>
					</li>
				</ul>
			</div>
		</div>

		<fab
			:type="type"
			:data="data"
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>

		<template v-if="!data.customer">
			<add-customer
				ref="addCustomer"
				@reload="reload"
				:data="data"
				:user="user"
				:isAuth="isAuth">
			</add-customer>
		</template>

		<send-email
			v-if="data"
			@reload="reload"
			ref="SendEmail"
			:item="data"
			:user="user"
			:isAuth="isAuth">
		</send-email>

		<add-agreement
			@reload="reload"
			v-if="data"
			ref="addAgreement"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</add-agreement>

		<change-status
			@reload="reload"
			ref="ChangeStatus"
			:user="user"
			:isAuth="isAuth">
		</change-status>

		<print
			v-if="data"
			ref="Print"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</print>

		<partial-payments
			@reload="reload"
			ref="partialPayments"
			:invoice="data"
			:user="user"
			:isAuth="isAuth">
		</partial-payments>

		<due-date
			@reload="reload"
			v-if="data"
			ref="dueDate"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</due-date>

		<settings
			ref="settings"
			@reload="reload"
			@openCollectionAccounts="$refs.collectionAccounts.open()"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</settings>

		<withholdings
			ref="withholdings"
			@reload="reload"
			:data="data"
			:user="user"
			:isAuth="isAuth">
		</withholdings>

		<template v-if="data.payment_method">
			<template v-if="data.payment_method.collection_accounts">
				<template v-if="data.payment_method.collection_accounts.length">
					<template v-if="data.payment_method.collection_accounts.length > 1">
						<collection-accounts
							@reload="reload"
							ref="collectionAccounts"
							:data="data"
							:user="user"
							:isAuth="isAuth">
						</collection-accounts>
					</template>
				</template>
			</template>
		</template>
	</nav>
</template>

<script>
	import swal from 'sweetalert2'
	import Fav from './Fab'
	import AddCustomer from './AddCustomer'
	import SendEmail from './SendEmail'
	import ChangeStatus from './ChangeStatus'
	import AddAgremment from './AddAgreement'
	import Print from './Print'
	import PartialPayments from '@/components/management/partialPayments/layout/PartialPayments'
	import DueDate from './DueDate'
	import Settings from './Settings'
	import CollectionAccounts from './CollectionAccounts'
	import Withholdings from './Withholdings'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			'fab': Fav,
			'add-agreement': AddAgremment,
			'send-email': SendEmail,
			'change-status': ChangeStatus,
			'print': Print,
			'partial-payments': PartialPayments,
			'due-date': DueDate,
			'settings': Settings,
			'collection-accounts': CollectionAccounts,
			'withholdings': Withholdings,
			'add-customer': AddCustomer,
		},
		data () {
			return {

			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			//--
			rectify() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: 'Se generará una factura rectificativa',
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/invoices/' + that.data.id + '/rectify')
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								if(response.status == 409) {
									swal({
										title: response.body.title,
										text: response.body.text,
										type: 'warning',
									})
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									})
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			doPrint() {
				this.$refs.Print.open()
			},
			openSettings() {
				this.$refs.settings.open()
			},
			removeCustomer() {
				var that = this
				swal.queue([{
						title: this.$t("messages.attention"),
						text: "Se removerá el cliente de la facutra",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							that.loading = true
							return new Promise(function (resolve) {
								that.data.customer_id = null
								that.$http.put('admin/management/invoices/' + that.data.id, that.data)
								.then(response => {
									that.loading = false
									that.$emit('reload')
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type,
									})
								}).catch(function(response) {
									that.loading = false
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Navbar.vue